import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PrintService {
  /**
   * Ist true, während die Druckvorschau geöffnet ist
   * und false, wenn sie geschlossen wurde
   */
  isPrinting = new BehaviorSubject<boolean>(false);

  constructor(private router: Router) { }

  /**
   * Öffnet die Druck-Ansicht eines Dokuments in einem neuen Tab,
   * gibt den Parameter via URL mit.
   * @param document was gedruckt werden soll (zB. Bestellung)
   * @param param ein mitgegebener Parameter (zB. m_selectedOrder)
   */
  printDocument(document: string, param: string) {
    let url = './uebersicht(print:print/' + document + '/' + param + ')';
    this.router.navigate([]).then(result => { window.open(url, '_blank'); });
  }

  /**
   * Wenn die Daten fertig geladen wurden,
   * wird der browsereigene Drucken-Dialog aufgerufen
   */
  onDataReady() {
    setTimeout(() => {
      window.print();
      this.isPrinting.next(false);
      window.close();

      this.router.navigate([{ outlets: { print: null } }]);
    }, 300);
  }
}